---
date: 2024-05-21
title: Maintenance
---

The indoor= codebase has been updated to use vue 3. Everything should mostly look the same as before.

[Open an issue](https://github.com/indoorequal/indoorequal.org/issues) if you have any problems.
